import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import { Config } from "../utils/Config";
import { connect } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import { citiesData } from "../utils/cities-data-no-stncode.js";
import { setCookie, getCookie, CookieName } from "../utils/cookieManager";
import { populateBusList, setSearchQuery, resetFilter } from "../actions/main";
import { LOCALSTORAGE_KEY } from "../utils/constants.js";
import BuslistCard from "./buslist-card";
import "../App.scss";
import ReactGA from "react-ga";

class Buslisting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      NObuses: false,
      showRTC: false
    };
  }

  componentDidMount() {
    // debugger;
    let { from, to, doj } = this.props.match.params;
    var date = doj.split("-");
    date = `${date[2]}-${date[1]}-${date[0]}`;
    let sq = this.props.searchQuery;
    let smasterid = this.props.searchQuery.source.masterId;
    let dmasterid = this.props.searchQuery.destination.masterId;
    // console.log(getCookie("SearchClicked"));
    let { filters, buses } = this.props.busListingReducer;
    console.log(this.props.busListingReducer);

    if (
      filters["FILTER_BUS_TYPE"].length > 0 ||
      filters["FILTER_BOARDING"].length > 0 ||
      filters["FILTER_DROPPING"].length > 0 ||
      filters["SORT"].length > 0 ||
      filters["FILTER_ARRIVAL_TIME"] !== "" ||
      filters["FILTER_DEPART_TIME"] !== ""
    ) {
      this.setState({
        isFilterApplied: true
      });
    }

    if (
      getCookie("SearchClicked") &&
      sq.source.city &&
      sq.destination.city &&
      sq.source.city === from &&
      sq.destination.city === to &&
      sq.doj === date
    ) {
      // if (buses[0].isRTC) {
      //   this.setState({
      //     RTCbuses: true
      //   });
      // }
      //do nothing just ignore
    } else {
      console.log("setting reducer...");
      const fromArray = citiesData.filter(city => city.value.match(from));
      const toArray = citiesData.filter(city => city.value.match(to));
      const fromquery = {
        type: "source",
        data: {
          city: fromArray[0].value,
          masterId: fromArray[0].masterId
        }
      };
      const toquery = {
        type: "destination",
        data: {
          city: toArray[0].value,
          masterId: toArray[0].masterId
        }
      };

      const dojquery = {
        type: "doj",
        data: date
      };

      this.props.setSearchQuery(fromquery);
      this.props.setSearchQuery(toquery);
      this.props.setSearchQuery(dojquery);

      window.localStorage.setItem(
        LOCALSTORAGE_KEY.SOURCE_CITY,
        JSON.stringify(fromquery)
      );

      window.localStorage.setItem(
        LOCALSTORAGE_KEY.DESTINATION_CITY,
        JSON.stringify(toquery)
      );
      window.localStorage.setItem(
        LOCALSTORAGE_KEY.DOJ,
        JSON.stringify(dojquery)
      );
      smasterid = fromArray[0].masterId;
      dmasterid = toArray[0].masterId;
      this.fetchbus(smasterid, dmasterid, date);
    }
  }

  fetchbus = (smasterid, dmasterid, doj) => {
    this.setState({
      isLoading: true
    });

    const busUrl = `${Config.SECURED_API_HOST}/api/platform/bus/getavailabletrips?sourceMasterId=${smasterid}&destinationMasterId=${dmasterid}&dateOfJourney=${doj}&fromDevice=desktop`;

    fetch(busUrl)
      .then(res => res.json())
      .then(res => {
        if (res.Error === null) {
          let buses = [];

          buses = res["buses"];

          console.log(buses);
          if ((buses && buses.length > 1) || buses[0].buses.length > 0) {
            this.props.populateBusList({
              buses: buses
            });
            setCookie("SearchClicked", true, 10);
          } else {
            console.log("No buses Found ");
            this.setState({
              NObuses: true
            });
          }

          this.setState({
            isLoading: false
          });
        } else {
          console.log("No buses Found ");
          this.setState({
            NObuses: true,
            isLoading: false
          });
        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ isLoading: false });
        this.openSnackBar("Something Went Wrong! Please Try Again ");
      });
  };

  handleFilterClick = () => {
    this.props.history.push("/bus-booking-phonepe/filters");
  };

  handlereset = () => {
    this.props.resetFilter();
    this.setState({ isFilterApplied: false, showRTCbuslist: false });
  };

  openSnackBar = message => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({ isSnackBarOpen: true, message: msg });
  };

  handleClose = () => {
    this.setState({ isSnackBarOpen: false });
  };

  showRTCBuses = () => {
    this.setState({
      showRTC: this.state.showRTC ? false : true
    });
  };

  render() {
    let { from, to, doj } = this.props.match.params;
    doj = `${doj.split("-")[2]}-${doj.split("-")[1]}-${doj.split("-")[0]}`;
    var date = new Date(doj);
    const bus = this.props.busListingReducer.buses;
    const Totalbuses =
      parseInt(bus.length) -
      1 +
      (bus[0] && bus[0].buses ? parseInt(bus[0].buses.length) : 0);

    const Nobuses = (
      <div style={{ margin: " 30% 10%", textAlign: "center" }}>
        <h3>
          No Buses Found Please
          <br />
          <p
            style={{ color: "#007bff" }}
            onClick={() => this.props.history.goBack()}
          >
            {" Click here"}
          </p>
        </h3>
      </div>
    );

    const header = (
      <div className="header">
        <Grid container justify="flex-start" className="from-to">
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid>
          <Grid item xs={5}>
            <div className="from">
              <span>{from.split(",")[0]}</span>
              <br />
              <span style={{ fontSize: "1.2rem" }}>{date.toDateString()}</span>
            </div>
          </Grid>
          <Grid item xs={1}>
            <i className="material-icons toArrow">arrow_right_alt</i>
          </Grid>
          <Grid item xs={4} className="to">
            <span>{to.split(",")[0]}</span>
            <br />
            <span style={{ fontSize: "1.2rem" }}>
              {" No of Buses - " + Totalbuses}
            </span>
          </Grid>
          <Grid item xs={1} className="to" onClick={this.handleFilterClick}>
            <img
              src="https://www.confirmtkt.com/img/react/filter-50.png"
              width="25px"
              height="25px"
              alt="Filter"
            />
          </Grid>
        </Grid>
      </div>
    );

    const buslist = (
      <BuslistCard
        busobj={this.props.busListingReducer}
        info={this.props.searchQuery}
        history={this.props.history}
      />
    );

    const RTCbuslist = (
      <BuslistCard
        busobj={this.props.busListingReducer.buses[0]}
        history={this.props.history}
        info={this.props.searchQuery}
      />
    );

    const container = this.state.isLoading ? (
      <div className="loading">
        <CircularProgress />
      </div>
    ) : (
      buslist
    );

    const clearFilter = (
      <div className="bottom-fixed-details">
        <div
          variant="contained"
          className="filter-button"
          style={{ background: "#949494" }}
        >
          <Grid container justify="flex-start">
            <Grid item xs={12} onClick={this.handlereset}>
              <span>{"Clear Filters"}</span>
            </Grid>
          </Grid>
        </div>
      </div>
    );

    return (
      <div className="bus-booking">
        {header}

        <div style={{ marginBottom: "6rem" }}>{container}</div>
        {this.state.NObuses ? Nobuses : ""}
        {this.state.isFilterApplied ? clearFilter : ""}

        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          autoHideDuration={1000}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchQuery: state.searchReducer,
    busListingReducer: state.busListingReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    populateBusList: res => {
      dispatch(populateBusList(res));
    },
    setSearchQuery: query => {
      dispatch(setSearchQuery(query));
    },
    resetFilter: reset => {
      dispatch(resetFilter(reset));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Buslisting);
